import React, {useEffect, useState} from 'react';
import {UserAndPermissionDto} from "../../../../../../../dtos";
import {makeStyles} from "@mui/styles";
import {Box, Table, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import UserAndPermissionRow from "./userAndPermissionRow";
import {SortBtn} from "../../../../../../com/sortBtn/sortBtn";
import {ConfigDto} from "../../../../../../flippingFlyersCatalog/flippingFlyerTocTab";
import {findUserRole} from "../../../../../../../globals/globFunctions";
import {updateUsersData} from "../../../../../../../store/actionCreators/usersAndPermissionActionCreators";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";

const useStyles = makeStyles(() => ({
    userAndPermissionTableWrapper: {
        maxHeight: "50vh",
        overflow: "auto",
        border: "2px solid #e2e2e2",
        borderRight: "none",
    },
    userAndPermissionTable: {
        borderCollapse: "collapse",
        margin: 0
    },
    storeSettingTableHeadRow: {
        "& > .MuiTableCell-root": {
            verticalAlign: "bottom",
            borderBottom: "2px solid #dee2e6",
            textAlign: "center",
            border: "none",
            zIndex: 1,
            minWidth: "32px",
            padding: "8px",
            backgroundColor: "#d4dade",
            fontWeight: "700",
            position: "sticky",
            top: 0,
            boxShadow: "0 0 0 2px #e8e8e8",
            borderTop: 0,
            borderRight: "2px solid #e2e2e2"
        }
    },
    headerBoxWithControl: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }
}))

interface IGuiThemesTable {
    onEdit: (userAndPermissionData: UserAndPermissionDto) => void;
    onDelete: (userAndPermissionData: UserAndPermissionDto) => void;
    // setDefaultSettingForStore: (storeSettingData: AccountStoreSettingDto) => void;
}


const UsersAndPermissionTable: React.FC<IGuiThemesTable> = ({
                                                                onEdit,
                                                                onDelete
                                                            }) => {
    const classes = useStyles();
    const {usersAndPermissions} = useTypedSelector((state) => state);
    const [isCloseMenu, setIsCloseMenu] = useState(true);
    const [sortConfig, setSortConfig] = useState<ConfigDto | null>(null);
    const dispatch = useDispatch();


    useEffect(() => {
        if (sortConfig) {
       let sortableItems = [...usersAndPermissions.usersAndPermissions];
            if (sortableItems) {
                sortableItems.sort((a: UserAndPermissionDto, b: UserAndPermissionDto) => {
                    if (sortConfig.caption === "acuRole") {
                        const roleCaptionA = findUserRole(Number(a[sortConfig.caption as keyof UserAndPermissionDto] || 1));
                        const roleCaptionB = findUserRole(Number(b[sortConfig.caption as keyof UserAndPermissionDto] || 1));
                        if (roleCaptionA.toString().toLowerCase() < roleCaptionB.toString().toLowerCase()) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (roleCaptionA.toString().toLowerCase() > roleCaptionB.toString().toLowerCase()) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    } else {
                        if (a[sortConfig.caption as keyof UserAndPermissionDto]!.toString().toLowerCase() < b[sortConfig.caption as keyof UserAndPermissionDto]!.toString().toLowerCase()) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[sortConfig.caption as keyof UserAndPermissionDto]!.toString().toLowerCase() > b[sortConfig.caption as keyof UserAndPermissionDto]!.toString().toLowerCase()) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    }
                });
                dispatch(updateUsersData(sortableItems));
            }
        }
    }, [sortConfig]);

    const onScroll = () => {
        setIsCloseMenu(true);
    }

    const items = usersAndPermissions.usersAndPermissions.map((userData: UserAndPermissionDto) => {
        return <UserAndPermissionRow
            key={userData.acuRecId}
            userData={userData}
            setIsCloseMenu={setIsCloseMenu}
            isCloseMenu={isCloseMenu}
            onEdit={onEdit}
            onDelete={onDelete}
        />

    })

    return (
        <div className={classes.userAndPermissionTableWrapper}>
            <Table className={classes.userAndPermissionTable} onScroll={onScroll}>
                <TableHead>
                    <TableRow className={classes.storeSettingTableHeadRow}>
                        <TableCell sx={{width: '18%'}}>
                            <Box className={classes.headerBoxWithControl}>
                                <Typography>First Name</Typography>
                                <SortBtn
                                    sortCaption={"acuFirstName"} items={usersAndPermissions.usersAndPermissions}
                                    setSortConfig={setSortConfig}
                                    sortConfig={sortConfig}/>
                            </Box>
                        </TableCell>
                        <TableCell sx={{width: '20%'}}>
                            <Box className={classes.headerBoxWithControl}>
                                <Typography>Last Name</Typography>
                                <SortBtn
                                    sortCaption={"acuLastName"} items={usersAndPermissions.usersAndPermissions}
                                    setSortConfig={setSortConfig}
                                    sortConfig={sortConfig}/>
                            </Box>
                        </TableCell>
                        <TableCell sx={{width: '15%'}}>
                            <Box className={classes.headerBoxWithControl}>
                                <Typography>Role</Typography>
                                <SortBtn
                                    sortCaption={"acuRole"} items={usersAndPermissions.usersAndPermissions}
                                    setSortConfig={setSortConfig}
                                    sortConfig={sortConfig}/>
                            </Box>
                        </TableCell>
                        <TableCell sx={{width: '41%'}}>
                            <Box className={classes.headerBoxWithControl}>
                                <Typography>Email</Typography>
                                <SortBtn
                                    sortCaption={"acuEmailAddress"} items={usersAndPermissions.usersAndPermissions}
                                    setSortConfig={setSortConfig}
                                    sortConfig={sortConfig}/>
                            </Box>
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>

                <tbody>{items}</tbody>
            </Table>
        </div>
    )
}

export default UsersAndPermissionTable